<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.33219 15.2575L4.74219 14.6675L9.40885 10.0008L4.74219 5.33414L5.33219 4.74414L9.99885 9.41081L14.6655 4.74414L15.2555 5.33414L10.5889 10.0008L15.2555 14.6675L14.6655 15.2575L9.99885 10.5908L5.33219 15.2575Z" fill="currentColor"/>
</svg>
